var map = {
	"./alert-box.entry.js": [
		63027,
		[
			63027
		]
	],
	"./confirmation-dialog_10.entry.js": [
		55297,
		[
			55297
		]
	],
	"./copy-resource-link-button.entry.js": [
		14083,
		[
			14083
		]
	],
	"./loader-component.entry.js": [
		28096,
		[
			28096
		]
	],
	"./ontotext-download-as.entry.js": [
		18096,
		[
			18096
		]
	],
	"./ontotext-dropdown.entry.js": [
		19518,
		[
			19518
		]
	],
	"./ontotext-editable-text-field.entry.js": [
		56182,
		[
			56182
		]
	],
	"./ontotext-explain-plan.entry.js": [
		17066,
		[
			17066
		]
	],
	"./ontotext-pagination.entry.js": [
		91179,
		[
			91179
		]
	],
	"./query-split-button.entry.js": [
		52925,
		[
			52925
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87483;
module.exports = webpackAsyncContext;